import React from 'react'
import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs'
import DmtcommschList from './dmtcommschList/DmtcommschList'

function DmtCommSche() {
 
  return (
    <>
    <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Commision",
    title_2: "DMT or AEPS Commision List",
  }}/>
    <DmtcommschList/>
    </>

  )
}

export default DmtCommSche